import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { Injectable } from "@angular/core";

@Injectable()
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}
  init() {
    this.matIconRegistry.addSvgIcon(
      "home",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/home.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "excel",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/excel.svg")
    );
    // InPlantLogistic
    this.matIconRegistry.addSvgIcon(
      "activity-point",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/activity-point.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "andon-material-call",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/andon-material-call.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "availability",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/availability.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "feeding-route",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/feeding-route.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "feeding-route-shift",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/feeding-route-shift.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "material-call",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/material-call.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "packaging-call",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/packaging-call.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "pfep",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/pfep.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "picking-area",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/picking-area.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "report-kpi",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/report-kpi.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "sequence",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/sequence.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "supply-area",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/supply-area.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "operation",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/operation.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "box-close",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/box-close.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "box-ko",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/box-ko.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "box-ok",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/box-ok.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "box-close",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/box-close.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "forklift",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/forklift.svg")
    );
    //ProductionQuality
    this.matIconRegistry.addSvgIcon(
      "approval",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/approval.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "calendar",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/calendar.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "control-plan",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/control-plan.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "documentation",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/documentation.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "execution-line",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/execution-line.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "execution-quality",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/execution-quality.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "execution-responsable",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/execution-responsable.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "mailing-list",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/mailing-list.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "quality-nc",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/quality-nc.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "quality-planning",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/quality-planning.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "user-group",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/user-group.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "user-management",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/user-management.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "account_circle",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/svgs/account_circle.svg")
    );
  }
}
